module.exports = __webpack_public_path__ + "img/Merkur-Logo-Kachel.c6356efc.png";